import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppContextMenu } from '@folio/stripes/core';
import { checkScope, CommandList, defaultKeyboardShortcuts, HasCommand, NavList, NavListItem, NavListSection, } from '@folio/stripes/components';
import { AcqKeyboardShortcutsModal, handleKeyCommand, useModalToggle, } from '@folio/stripes-acq-components';
import { CLAIMING_ROUTE } from './constants';
import { RootRoutes } from './RootRoutes';
var Root = function () {
    var _a = useModalToggle(), isOpen = _a[0], toggleModal = _a[1];
    var focusSearchField = function () {
        var el = document.getElementById('input-record-search');
        if (el) {
            el.focus();
        }
    };
    var shortcuts = [
        {
            name: 'search',
            handler: handleKeyCommand(focusSearchField),
        },
        {
            name: 'openShortcutModal',
            shortcut: 'mod+alt+k',
            handler: handleKeyCommand(toggleModal),
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(CommandList, { commands: defaultKeyboardShortcuts },
            React.createElement(HasCommand, { commands: shortcuts, isWithinScope: checkScope, scope: document.body },
                React.createElement(AppContextMenu, null, function (handleToggle) { return (React.createElement(NavList, null,
                    React.createElement(NavListSection, null,
                        React.createElement(NavListItem, { id: "claiming-app-search-item", to: {
                                pathname: CLAIMING_ROUTE,
                                state: { resetFilters: true },
                            }, onClick: function () {
                                handleToggle();
                                focusSearchField();
                            } },
                            React.createElement(FormattedMessage, { id: "ui-claims.appMenu.claimingAppSearch" })),
                        React.createElement(NavListItem, { id: "keyboard-shortcuts-item", onClick: function () {
                                handleToggle();
                                toggleModal();
                            } },
                            React.createElement(FormattedMessage, { id: "stripes-acq-components.appMenu.keyboardShortcuts" }))))); }),
                React.createElement(RootRoutes, null))),
        isOpen && (React.createElement(AcqKeyboardShortcutsModal, { onClose: toggleModal }))));
};
export default Root;
